export function buildTearsheetAssistContext({
  customerId,
  fetchResult,
  mode,
  saveName,
  scorecardScoreOverrides = {},
}) {
  if (!fetchResult) return null;

  const scorecard = (fetchResult.cashflowScorecard || []).map((row) => {
    const override = scorecardScoreOverrides[row.key];
    return {
      key: row.key,
      label: row.label,
      score: override?.score ?? row.score,
      grade: override?.grade ?? row.grade,
      value: row.value,
      weight: row.weight,
    };
  });

  return JSON.stringify({
    customerId,
    mode,
    name: saveName || fetchResult.name || null,
    requestedFundingAmount: fetchResult.requestedFundingAmount,
    requestedFundingPct: fetchResult.requestedFundingPct,
    marketingSpendAmount: fetchResult.marketingSpendAmount,
    cashBalance: fetchResult.cashBalance,
    currentExposure: fetchResult.currentExposure,
    futureExposure: fetchResult.futureExposure,
    nextRepaymentAmount: fetchResult.nextRepaymentAmount,
    nextRepaymentDate: fetchResult.nextRepaymentDate,
    resultRows: fetchResult.resultRows,
    roasTargets: fetchResult.roasTargets,
    dealConstraints: fetchResult.dealConstraints,
    cashflowMetrics: fetchResult.cashflowMetrics,
    cashflowRoasVector: fetchResult.cashflowRoasVector,
    cashflowScorecard: scorecard,
    scorecardGradeThresholds: fetchResult.scorecardGradeThresholds,
    cacPrediction: fetchResult.cacPrediction
      ? {
          slope: fetchResult.cacPrediction.slope,
          intercept: fetchResult.cacPrediction.intercept,
          rSquared: fetchResult.cacPrediction.rSquared,
        }
      : null,
  });
}
